export default __webpack_public_path__ + "static/media/appstore_badge.08dab959.png";